import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  Box,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import {
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { useForm } from "../../../../hooks/useForm";
import AutoCompleteDiagnostico from "../../UI/AutoCompleteDiagnostico";
import { startAlerta } from "../../../../actions/ui/alertas";
import {
  getPresupuestosGestion,
  getTiposSolicitudes,
  savePresupuesto,
  updatePresupuesto,
  updatePresupuestoValues,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_PRESUPUESTOS_ESTADOS, TIPOS_AUTORIZACIONES } from "../../../../utils/constants";
import { InformacionDocumentacionPresupuesto } from "./InformacionDocumentacionPresupuesto";
import { CreateSharp } from "@material-ui/icons";
import { ModalModificarPrestador } from "./ModalModificarPrestador";

export const InformacionMenuPresupuesto = (props) => {
  const { disabled } = props;
  const dispatch = useDispatch();
  const { tiposSolicitudes = [], presupuestoSeleccionado = {} } = useSelector(
    (state) => state.autorizaciones
  );
  const [faltaDocumentacion, setFaltaDocumentacion] = useState(false);

  let presupuestoDefault = {
    idTipoSolicitud: "",
    cuitPrestador: "",
    nombrePrestador: "",
    fechaVencimiento: "",
    idEfectorFacturacion: "",
    idPrestador: "",
    idCartillaPrestador: "",
    idTipoPresupuesto: "",
    conInternacion: false,
    fechaPrescripcion: "",
    fechaProgramada: "",
    observacion: "",
    valor: "",
    valorSugerido: "",
    diagnostico: null,
    urgente: false,
    soloMateriales: false
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    !!presupuestoSeleccionado ? presupuestoSeleccionado : presupuestoDefault
  );

  const {
    idTipoSolicitud,
    cuitPrestador,
    nombrePrestador,
    fechaVencimiento,
    // idEfectorFacturacion,
    // idPrestador,
    // idCartillaPrestador,
    // idTipoPresupuesto,
    conInternacion,
    fechaPrescripcion,
    fechaProgramada,
    valor,
    valorSugerido,
    diagnostico,
    observacion,
    fechaOrden,
    fechaCarga,
    fechaCirugia,
    urgente,
    soloMateriales
  } = formValues;

  useEffect(() => {
    dispatch(getTiposSolicitudes());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      updatePresupuestoValues({
        diagnostico,
        idDiagnostico: diagnostico ? diagnostico.idProblema : null,
      })
    );
  }, [diagnostico]);

  useEffect(() => {
    dispatch(
      updatePresupuestoValues({
        idTipoSolicitud,
      })
    );
  }, [idTipoSolicitud]);

  useEffect(() => {
    //FechaPrescripcion
    ValidatorForm.addValidationRule("isAfterToday", (value) => {
      if (moment(value).isValid() && moment(value).isAfter(moment(), "day")) {
        return false;
      }
      return true;
    });

    //FechaProgramada
    ValidatorForm.addValidationRule("isBeforeFechaPrescripcion", (value) => {
      if (
        moment(value).isValid() &&
        moment(value).isBefore(moment(fechaPrescripcion), "day")
      ) {
        return false;
      }
      return true;
    });
  });

  const [conInternacionValue, setConInternacionValue] = useState(
    soloMateriales ? "materiales" : conInternacion ? "internacion" : "ambulatorio"
  );
  const [openModalModificarPrestador, setOpenModalModificarPrestador] = useState(false);

  const [radioUrgente, setRadioUrgente] = useState(
    urgente ? "si" : "no"
  );

  const practicaElegida = tiposSolicitudes.filter(
    (solicitud) => solicitud.idTipo === idTipoSolicitud
  )[0];

  const onSubmitHandler = () => {
    if (!diagnostico) {
      dispatch(startAlerta(`Falta el Diagnostico.`, "warning"));
    } else if (faltaDocumentacion && idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION) {
      dispatch(startAlerta(`Documentación Incompleta.`, "warning"));
    } else {
      dispatch(savePresupuesto(presupuestoSeleccionado, null, getPresupuestosGestion, props.filtros));
    }
  };

  const disabledUpdate = (presupuestoSeleccionado.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
    && presupuestoSeleccionado.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS)
    || presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS;


    const enabledUpdateValor = presupuestoSeleccionado.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
      && presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS;

  const modificarPrestador = (value) => {
    setearVariosValores({
      ...formValues,
      cuitPrestador: value.prestadorCuit,
      nombrePrestador: value.prestadorNombreApellido,
      idPrestador: value.idPrestador,
      idCartillaPrestador: value.idCartillaPrestador,
      idEfectorFacturacion: value.idEfectorFacturacion,
    });
    dispatch(
      updatePresupuesto("cuitPrestador", value.prestadorCuit)
    );
    dispatch(
      updatePresupuesto("nombrePrestador", value.prestadorNombreApellido)
    );
    dispatch(
      updatePresupuesto("idPrestador", value.idPrestador)
    );
    dispatch(
      updatePresupuesto("idCartillaPrestador", value.idCartillaPrestador)
    );
    dispatch(
      updatePresupuesto("idEfectorFacturacion", value.idEfectorFacturacion)
    );
  }

  return (
    <>
      {openModalModificarPrestador && (
        <ModalModificarPrestador
          open={openModalModificarPrestador}
          close={() => {
            setOpenModalModificarPrestador(false);
          }}
          formValues={formValues}
          modificar={modificarPrestador}
        />
      )}
      <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
        <Table style={{ width: "80%", margin: "auto" }}>
          <TableBody>
            <TableRow>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <TableCell
                  style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
                >
                  Tipo de Orden:
                </TableCell>
                <TableCell
                  style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
                >
                  {Array.isArray(tiposSolicitudes) && tiposSolicitudes?.length > 0 && (
                    <Select
                      style={{ width: "300px" }}
                      name="idTipoSolicitud"
                      value={idTipoSolicitud}
                      onChange={(e) => {
                        handleInputChange(e);
                        dispatch(
                          updatePresupuesto("idTipoSolicitud", e.target.value)
                        );
                      }}
                      disabled={true}
                    >
                      {Array.isArray(tiposSolicitudes) &&
                        tiposSolicitudes?.length > 0 &&
                        tiposSolicitudes.map((tipoSolicitud) => (
                          <MenuItem
                            key={tipoSolicitud.idTipo}
                            value={tipoSolicitud.idTipo}
                          >
                            {tipoSolicitud.descripcionTipo}
                          </MenuItem>
                        ))}
                    </Select>
                  )}
                </TableCell>
              </Box>
            </TableRow>
          </TableBody>
        </Table>
        <Table
          style={{ width: "80%", margin: "auto" }}
        >
          <TableBody>
            <TableRow>
              <TableCell
                style={{
                  borderBottom: "0",
                  fontSize: "1rem",
                  verticalAlign: "bottom",
                  position: "relative",
                  bottom: "2px",
                }}
              >
                Diagnostico:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                <AutoCompleteDiagnostico
                  disabled={disabledUpdate}
                  autoCompleteValue={diagnostico}
                  onChangeHandler={(value) => {
                    setearValor("diagnostico", value);
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Table
          style={{ width: "80%", margin: "auto" }}
        >
          <TableBody>
            <TableRow>
              <TableCell
                style={{
                  borderBottom: "0",
                  fontSize: "1rem",
                  verticalAlign: "bottom",
                  position: "relative",
                  bottom: "10px",
                }}
              >
                Urgente:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", justifyContent: "left" }}
                >
                  <RadioGroup
                    row
                    value={radioUrgente}
                    defaultValue={radioUrgente}
                    onChange={(e) => {
                      dispatch(
                        updatePresupuesto(
                          "urgente",
                          e.target.value === "si"
                        )
                      );
                      setearVariosValores({
                        urgente: e.target.value === "si"
                      });
                      setRadioUrgente(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value={"si"}
                      control={<Radio />}
                      label="SI"
                      disabled={disabledUpdate}
                    />
                    <FormControlLabel
                      value={"no"}
                      control={<Radio />}
                      label="NO"
                      disabled={disabledUpdate}
                    />
                  </RadioGroup>
                </Grid>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        {presupuestoSeleccionado?.idSolicitudAutorizada !== null && <Table style={{ width: "80%", margin: "auto" }}>
          <TableBody>
            <TableRow>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <TableCell
                  style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
                >
                  N° Orden:
                </TableCell>
                <TableCell
                  style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
                >
                  {presupuestoSeleccionado?.idSolicitudAutorizada}
                </TableCell>
              </Box>
            </TableRow>
          </TableBody>
        </Table>}
        <Grid style={{ margin: "0.5rem 0" }}>
          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "0.5rem",
            }}
          >
            <React.Fragment>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <RadioGroup
                  row
                  value={conInternacionValue}
                  defaultValue={conInternacionValue}
                  onChange={(e) => {
                    dispatch(
                      updatePresupuesto(
                        "conInternacion",
                        e.target.value === "internacion"
                      )
                    );
                    dispatch(
                      updatePresupuesto(
                        "soloMateriales",
                        e.target.value === "materiales"
                      )
                    );
                    setConInternacionValue(e.target.value);
                    setearVariosValores({
                      conInternacion: e.target.value === "internacion",
                      soloMateriales: e.target.value === "materiales",
                      fechaPrescripcion: "",
                      fechaProgramada: "",
                    });
                  }}
                >
                  <FormControlLabel
                    value={"ambulatorio"}
                    control={<Radio />}
                    label="Ambulatoria"
                    disabled={disabled}
                  />
                  <FormControlLabel
                    value={"internacion"}
                    control={<Radio />}
                    label="Con internación"
                    disabled={disabled}
                  />
                  <FormControlLabel
                    value={"materiales"}
                    control={<Radio />}
                    label="Solo materiales"
                    disabled={disabled}
                  />
                </RadioGroup>
              </Grid>
              {conInternacion && (
                <>
                  <Grid item xs={0} sm={2}></Grid>
                  <Grid item xs={12} sm={4}>
                    <MuiPickersUtilsProvider
                      locale={esLocale}
                      utils={DateFnsUtils}
                    >
                      <ValidatedDatePicker
                        fullWidth={true}
                        margin="normal"
                        format="dd/MM/yyyy"
                        okLabel="Aceptar"
                        disabled={disabledUpdate}
                        clearLabel="Limpiar"
                        cancelLabel="Cancelar"
                        label="Fecha Prescripción"
                        name="fechaPrescripcion"
                        value={
                          fechaPrescripcion !== undefined &&
                            moment(fechaPrescripcion).isValid()
                            ? moment(fechaPrescripcion)
                            : null
                        }
                        onChange={(e) => {
                          setearValor("fechaPrescripcion", e);
                          dispatch(
                            updatePresupuesto("fechaPrescripcion", moment(e))
                          );
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        maxDate={new Date()}
                        validators={
                          practicaElegida?.requiereFechaPrescripcion && [
                            "required",
                            "isAfterToday",
                          ]
                        }
                        errorMessages={
                          practicaElegida?.requiereFechaPrescripcion && [
                            "La fecha de prescripción es requerida",
                            "La fecha de prescripción no puede ser mayor a la fecha actual",
                          ]
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <MuiPickersUtilsProvider
                      locale={esLocale}
                      utils={DateFnsUtils}
                    >
                      <ValidatedDatePicker
                        fullWidth={true}
                        margin="normal"
                        format="dd/MM/yyyy"
                        okLabel="Aceptar"
                        disabled={disabledUpdate}
                        clearLabel="Limpiar"
                        cancelLabel="Cancelar"
                        label="Fecha Programada"
                        name="fechaProgramada"
                        value={
                          fechaProgramada !== undefined &&
                            moment(fechaProgramada).isValid()
                            ? moment(fechaProgramada)
                            : null
                        }
                        onChange={(e) => {
                          setearValor("fechaProgramada", e);
                          dispatch(
                            updatePresupuesto("fechaProgramada", moment(e))
                          );
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        minDate={fechaPrescripcion}
                        validators={
                          practicaElegida?.requiereFechaProgramada && [
                            "required",
                            "isBeforeFechaPrescripcion",
                          ]
                        }
                        errorMessages={
                          practicaElegida?.requiereFechaProgramada && [
                            "La fecha programada es requerida",
                            "La fecha programada no puede ser menor a la fecha fecha de prescripción",
                          ]
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={0} sm={2}></Grid>
                </>
              )}
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
                >
                  <ValidatedDatePicker
                    fullWidth={true}
                    margin="normal"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    disabled={disabledUpdate}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    label="Fecha Orden"
                    name="fechaOrden"
                    value={
                      fechaOrden !== undefined &&
                        moment(fechaOrden).isValid()
                        ? moment(fechaOrden)
                        : null
                    }
                    onChange={(e) => {
                      setearValor("fechaOrden", e);
                      dispatch(
                        updatePresupuesto("fechaOrden", moment(e))
                      );
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
                >
                  <ValidatedDatePicker
                    fullWidth={true}
                    margin="normal"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    disabled={disabledUpdate}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    label="Fecha Carga"
                    name="fechaCarga"
                    value={
                      fechaCarga !== undefined &&
                        moment(fechaCarga).isValid()
                        ? moment(fechaCarga)
                        : null
                    }
                    onChange={(e) => {
                      setearValor("fechaCarga", e);
                      dispatch(
                        updatePresupuesto("fechaCarga", moment(e))
                      );
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
                >
                  <ValidatedDatePicker
                    fullWidth={true}
                    margin="normal"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    disabled={disabledUpdate}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    label="Fecha Cirugía"
                    name="fechaCirugia"
                    value={
                      fechaCirugia !== undefined &&
                        moment(fechaCirugia).isValid()
                        ? moment(fechaCirugia)
                        : null
                    }
                    onChange={(e) => {
                      setearValor("fechaCirugia", e);
                      dispatch(
                        updatePresupuesto("fechaCirugia", moment(e))
                      );
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={4}>
                <MuiPickersUtilsProvider
                  locale={esLocale}
                  utils={DateFnsUtils}
                >
                  <ValidatedDatePicker
                    fullWidth={true}
                    margin="normal"
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    disabled={disabledUpdate}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    label="Fecha Vencimiento"
                    name="fechaVencimiento"
                    value={
                      fechaVencimiento !== undefined &&
                        moment(fechaVencimiento).isValid()
                        ? moment(fechaVencimiento)
                        : null
                    }
                    onChange={(e) => {
                      setearValor("fechaVencimiento", e);
                      dispatch(
                        updatePresupuesto("fechaVencimiento", moment(e))
                      );
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    minDate={fechaPrescripcion}
                    validators={
                      practicaElegida?.requiereFechaFinPresupuesto && [
                        "required",
                        "isBeforeFechaPrescripcion",
                      ]
                    }
                    errorMessages={
                      practicaElegida?.requiereFechaFinPresupuesto && [
                        "La fecha vencimiento es requerida",
                        "La fecha vencimiento no puede ser menor a la fecha fecha programada",
                      ]
                    }
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextValidator
                  style={{ marginTop: "1rem", marginLeft: "1rem" }}
                  label="Valor Presupuesto"
                  name="valor"
                  disabled={enabledUpdateValor ? false : disabledUpdate}
                  // onChange={(e) => {
                  //   // props.setHaveChangeValues(true);
                  //   props.setearValor("valor", e.target.value);
                  // }}
                  // InputLabelProps={{ shrink: true }}  
                  value={valor}
                  onChange={(e) => {
                    setearValor("valor", e.target.value);
                    dispatch(
                      updatePresupuesto("valor", e.target.value)
                    );
                  }}
                  validators={['required', 'isPositive']}
                  errorMessages={['El valor es requerido', 'Solo se permiten números']}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextValidator
                  style={{ marginTop: "1rem", marginLeft: "1rem" }}
                  label="Valor Aprobado"
                  name="valorSugerido"
                  onChange={(e) => {
                    setearValor("valorSugerido", e.target.value);
                    dispatch(
                      updatePresupuesto("valorSugerido", e.target.value)
                    );
                  }}
                  disabled={enabledUpdateValor ? false : disabledUpdate}
                  // InputLabelProps={{ shrink: true }}  
                  value={valorSugerido}
                // validators={['required', 'isPositive']}
                // errorMessages={['El valor es requerido', 'Solo se permiten números']}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextValidator
                  margin="normal"
                  value={cuitPrestador}
                  disabled={true}
                  inputProps={{ maxLength: 11 }}
                  // onChange={(e) => {
                  //     props.setHaveChangeValues(true);
                  //     props.setearValor("cuitPrestador", e.target.value);
                  // }}
                  fullWidth
                  label="Cuit Prestador"
                  name="cuitPrestador"
                  autoComplete="off"
                // InputLabelProps={{ shrink: true }}  
                // validators={[
                //     "required", 
                //     "isPositive", 
                //     "minNumber:10000000000"
                // ]}
                // errorMessages={[
                //     "El valor es requerido",
                //     "Solo se permiten números",
                //     "El cuit debe tener 11 dígitos"
                // ]}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button variant="contained"
                  color="primary"
                  disabled={disabledUpdate}
                  style={{ marginTop: 15 }}
                  onClick={() => setOpenModalModificarPrestador(true)}
                >
                  <CreateSharp />
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextValidator
                  margin="normal"
                  value={nombrePrestador}
                  disabled={true}
                  // inputProps={{ maxLength: 100}}
                  // onChange={(e) => {
                  //     props.setHaveChangeValues(true);
                  //     props.setearValor("nombrePrestador", e.target.value);
                  // }}
                  fullWidth
                  label="Nombre Prestador"
                  name="nombrePrestador"
                  autoComplete="off"
                // InputLabelProps={{ shrink: true }}  
                // validators={["required"]}
                // errorMessages={["El valor es requerido"]}
                />
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  margin="normal"
                  value={observacion}
                  disabled={disabledUpdate}
                  onChange={(e) => {
                    setearValor("observacion", e.target.value);
                    dispatch(updatePresupuesto("observacion", e.target.value)); // Corrección aquí
                  }}
                  fullWidth
                  label="Observación"
                  name="observacion"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                //validators={["required"]}
                //errorMessages={["El valor es requerido"]}
                />
              </Grid>
            </React.Fragment>
          </Grid>
          <InformacionDocumentacionPresupuesto
            disabled={disabledUpdate}
            setFaltaDocumentacion={setFaltaDocumentacion}
          />
          <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
            <Button
              variant="contained"
              color="primary"
              disabled={enabledUpdateValor ? false : disabledUpdate}
              type="submit"
            >
              Guardar Cambios
            </Button>
          </div>
        </Grid>
      </ValidatorForm>
    </>

  );
};
